// Account-level policy for the "LSG …" marker tags the tool stamps on pages it creates
// ("LSG Tool", "LSG Service Area Page", …). Agency (white-label) accounts can turn these OFF from
// Settings → WP Integration so a client can't see them in WordPress. The setting lives on the user
// account (server) and applies to every connected site; App mirrors it into this module-global on
// load and whenever it changes, so the page-creation paths (fixExecutor) can read it synchronously.
//
// IMPORTANT: this only affects the *visible tags*. The durable `_lsg_*` meta keys the tool writes to
// track its own history are never touched — hiding the tags doesn't break "created by the tool".

let suppress = false;

// Set from App based on the signed-in account (white-label AND the toggle enabled).
export function setSuppressLsgTags(v: boolean): void { suppress = v; }

// True when the tool should omit LSG marker tags on newly created pages.
export function suppressingLsgTags(): boolean { return suppress; }

// A tag is an LSG marker if it's one of the tool's identifying tags — matched as any tag whose name
// starts with "LSG " (covers "LSG Tool", "LSG Service Area Page", and any future "LSG …" marker).
// Content tags like "InnerPage", "Article", and blog topic tags are NOT markers and are kept.
export function isLsgMarkerTag(name: string): boolean {
  return name.trim().toLowerCase().startsWith("lsg ");
}

// Filter a create-time tag list per the account setting: drop LSG marker tags when suppression is on.
export function applyTagPolicy(tags: string[]): string[] {
  return suppress ? tags.filter(t => !isLsgMarkerTag(t)) : tags;
}
